export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-black/10">
      <div className="mx-auto max-w-[1600px] px-5 py-16 md:px-10">
        <div className="flex flex-wrap items-center justify-between gap-6">
          <span className="flex items-center">
            <img src="/assets/logo-dark.png" alt="DSA eCommerce" className="h-7 w-auto" />
            <span className="ml-3 font-mono2 text-[10px] font-normal uppercase tracking-[0.25em] text-ink/40">
              Est. 2016 · 10th Anniversary
            </span>
          </span>
          <div className="flex gap-8 font-mono2 text-[10px] uppercase tracking-[0.2em] text-ink/50">
            <a
              href="https://www.dsaecommerce.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-main-site-link"
              className="transition-colors duration-200 hover:text-ink"
            >
              dsaecommerce.com
            </a>
            <a
              href="https://www.dsaecommerce.com/earnings-claims"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-earnings-link"
              className="transition-colors duration-200 hover:text-ink"
            >
              Earnings Claims
            </a>
          </div>
        </div>
        <p
          data-testid="footer-disclaimer"
          className="mt-12 max-w-4xl font-body text-xs leading-relaxed text-ink/35"
        >
          Earnings Disclaimer: Results shown on this page are real, individual
          client outcomes and are not typical. Your results will vary and depend
          on many factors, including your effort, experience, and market
          conditions. DSA eCommerce does not guarantee income, sales, or
          profits. The $10,000 commitment is a commitment to continue providing
          coaching — not a guarantee of income, profit, or results. Gross sales
          are total product revenue before fees, cost of goods, and expenses,
          and do not represent profit.
        </p>
      </div>
    </footer>
  );
}
